/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 * A small portion of this code is from angular-medium-editor: https://github.com/thijsw/angular-medium-editor
 */
'use strict';

/**
 * A directive modifies an element already annotated with the medium editor clone to also use the
 * medium-editor-insert-plugin.
 *
 * A few other modifications to make the editor work nicely within bulb have been added as well.
 */
angular.module('bulbApp.contentSelectorModule')

.directive('contentSelector', ['$timeout','BulbCommentService','MediumEditor', contentSelector]);

function contentSelector($timeout, BulbCommentService, MediumEditor) {
  return {
    priority: 999,
    require: 'ngModel',
    restrict: 'A',
    controller: 'ContentSelectorController as contentSelectorCtrl',
    link: function link(scope, elem, attr, ngModel) {

      var page = scope.$eval(attr.page);

      if (!BulbCommentService.isCommentable(page)) {
        // Need to re-init the comment service even if comments are not enabled, so that it clears out any
        // previous comments
        BulbCommentService.init(page, elem);
        return;
      }

      var contentSelectorCtrl = scope.contentSelectorCtrl;
      contentSelectorCtrl.page = page;

      ngModel.editor = new MediumEditor(elem, contentSelectorCtrl.editorOptions); // jshint ignore:line
      contentSelectorCtrl.editor = ngModel.editor;
      contentSelectorCtrl.editorElement = elem[0];

      var toolbar = ngModel.editor.getExtensionByName('toolbar');
      toolbar.on(toolbar.document.documentElement, 'touchend', toolbar.handleDocumentMouseup.bind(toolbar));

      BulbCommentService.init(contentSelectorCtrl.page, elem, ngModel.editor);
    }
  };
}
